<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>服务费明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
        <div>
            <p class="worker-title">
            <span>{{salaryInfo.worker.workerName}}</span>
            <span></span>
            </p>
            <p class="info-item">所属月份：{{salaryInfo.workerMonthSalary.yearMh}}</p>
            <p class="info-item">服务费总额：{{salaryInfo.workerMonthSalary.sumSalary}}</p>
            <p class="info-item">开户行：{{salaryInfo.worker.openBank}}</p>
            <p class="info-item">银行卡号：{{salaryInfo.worker.bankCardNo}}</p>
            <p class="worker-title">服务者标签：</p>
            <div style="margin-bottom:20px;">
              <el-table
             size="mini"
              :data="salaryInfo.workerLabel"
              border
              style="width: 1200px"
              class="table"
              v-if="salaryInfo.workerLabel.length>=1"
            >
              <!-- <el-table-column prop="id" label="ID" width="80px" fixed="left"></el-table-column> -->

              <el-table-column prop="workerName" label="姓名"></el-table-column>

              <el-table-column prop="lableType" label="标签类型"></el-table-column>
              <el-table-column prop="state" label="状态"></el-table-column>
  
              <el-table-column
                prop="effectiveStart"
                label="有效期开始"
                width="160px"
                :formatter="dateFormatA"
              ></el-table-column>
              <el-table-column
                prop="effectiveEnd"
                label="有效期结束"
                width="160px"
                :formatter="dateFormatA"
              ></el-table-column>
                         <el-table-column prop="auditUserName" label="审核人"></el-table-column>
                         <el-table-column prop="auditRemark" label="审核备注" width="160px"></el-table-column>
 <el-table-column
                prop="auditDate"
                label="审核时间"
                width="160px"
                :formatter="dateFormatA"
              ></el-table-column>
            </el-table>
            </div>

        </div>
      <!-- accordion -->
      <el-collapse v-model="activeOrder">
        <el-collapse-item
          v-for="(item, index) in salaryInfo.monthTypeTotal"
          :key="index"
          :name="index"
        >
          <template slot="title">
            <div class="salary-title">
              <span>{{item.salaryTypeName}}</span>
              <span style="color:#409EFF">{{item.typeCount.sumTypeSalary?(item.typeCount.sumTypeSalary+' 元'):''}}</span>
            </div>
          </template>
          <div>
              <p><el-button  type="primary" plan @click="auditSummary(item.salaryTypeId)">申诉</el-button></p>
            <el-table
             size="mini"
              :data="item.typeList"
              border
              style="width: 100%;margin-top:20px;"
              class="table"
              v-if="item.typeList.length>=1"
            >
              <el-table-column prop="id" label="ID" width="80px" fixed="left"></el-table-column>
              <el-table-column prop="workerNo" label="编号"  width="100px" fixed="left"></el-table-column>
              <el-table-column prop="workerName" label="姓名"></el-table-column>

              <el-table-column prop="isAppeal" label="是否有申诉">
          <template slot-scope="scope">
           <span v-if="scope.row.isAppeal==0">无</span>
           <span v-if="scope.row.isAppeal==1">有</span>
          </template>
        </el-table-column>
              <el-table-column prop="salary" label="费用"></el-table-column>
            
              <el-table-column
                prop="dates"
                label="日期"
                :formatter="dateFormatA"
                width="160px"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                :formatter="dateFormatA"
                width="160px"
              ></el-table-column>
               <el-table-column prop="remark" label="备注" width="280px"></el-table-column>

              <el-table-column prop label="操作" fixed="right" width="200px" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="auditDetail(scope.row)">申诉</el-button>
                  <el-button type="text" @click="showColumnDetail(scope.row)">明细信息</el-button>
                </template>
               
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

       <el-dialog
      title="申诉"
      :visible.sync="auditVisible"
      width="660px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addAuditForm"
        :rules="addAuditRules"
        label-width="120px"
        :model="addAuditForm"
        size="medium"
      
      >
        
       
          <el-row>
             <el-row style="color:red;text-index:50;">异议日期请选择核算月日期，如8月核对7月服务费，请选择7月对应日期</el-row>
            <el-form-item label="异议日期" prop="objectionDate" >
             
            
                <el-date-picker
                style="width:300px"
                  v-model="addAuditForm.objectionDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
            
            </el-form-item>
            </el-row>
            <el-row>
             <el-form-item label="异议金额" prop="complainFee"  style="width:420px">
          <!-- style="width:215px" -->
          <el-input v-model="addAuditForm.complainFee" disabled clearable></el-input>
        </el-form-item>
        </el-row>
        <el-row>
         <el-form-item label="修正金额" prop="correctErrorFee" style="width:420px">
          <!-- style="width:215px" -->
          <el-input v-model="addAuditForm.correctErrorFee" clearable></el-input>
        </el-form-item>
         
        </el-row>
        <el-row>
          <el-form-item label="申诉描述" prop="complainDesc">
            <el-input
              type="textarea"
              style="width:420px"
              :rows="3"
              placeholder="请输入申诉描述"
              v-model="addAuditForm.complainDesc"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:" prop="mark"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile"
          :on-change="handleOnChange"
          :file-list="addAuditImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <!-- </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible= false">取 消</el-button>
        <el-button type="primary" @click="confAddAudit('addAuditForm')">确 定</el-button>
      </span>
    </el-dialog>
 <!-- 详情 -->
    <el-dialog
      title="明细信息"
      :visible.sync="columnDetailVisible"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <el-table :data="columnData" border style="width: 100%" class="table">


        <el-table-column :prop="item.key" :label="item.value" v-for="(item,index) in columnList"  :key="index"></el-table-column>
        
        
    
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="columnDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
   
 


  </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
  components: { Pagination },
  data() {
     var checkNum = (rule, value, callback) => {
      console.log(value);
      // let reg=/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      let reg = /(^([-]?)[1-9]([0-9]+)?(.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9].[0-9]([0-9])?$)/;
     if (!reg.test(value)) {
        callback(new Error("请输入正确的金额格式，最多两位小数点"));
      } else {
        callback();
      }
    };
    return {
        columnDetailVisible:false,
      columnData:[],
      columnList:[],
      salaryTypeList:[],
      addAuditImgList:[],
      addAuditInfo:{},
       addFile: Service.addFile + globalData.userInfo.userAccount,
      auditVisible:false,
      addAuditForm:{
        complainFee:'',
        correctErrorFee:'',
        objectionDate:'',
        complainDesc:'',
      },
      addAuditRules: {
       
        complainFee: [
         { validator: checkNum, trigger: "blur" }, { required: true, message: "请输入异议金额", trigger: "change" }
        ],
        correctErrorFee: [
           { validator: checkNum, trigger: "blur" }, { required: true, message: "请输入修正金额", trigger: "change" }
        ],

        complainDesc: [
          { required: true, message: "请输入申诉描述", trigger: "change" }
        ],
        objectionDate: [
          { required: true, message: "请选择异议日期", trigger: "change" }
        ]
      },
      activeOrder: [0],
      salaryInfo: {
        monthTypeTotal: [],
        worker: {},
        workerLabel: [],
        workerMonthSalary: {}
      }
    };
  },
  created() {
    this.getSalaryInfo();
      Service.$axiosGetAllSalaryType()
        .then(res => {
          this.salaryTypeList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
  },
  activated(){
    this.getSalaryInfo();
  },
  methods: {
    getSalaryInfo() {
      Service.$axiosNewSelectMonthTypeSalary({
        workerNo: this.$route.query.workerNo,
        yearMonth: this.$route.query.yearMonth
      })
        .then(res => {
          console.log(res);
          this.salaryInfo = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    auditSummary(id) {
      this.addAuditForm={
         complainFee:0,
        correctErrorFee:'',
        objectionDate:'',
        complainDesc:'',
      };
      this.addAuditInfo.salaryType=id;
      this.addAuditInfo.id='';
      this.auditVisible=true;
    },
    auditDetail(row){
      this.auditVisible=true;
      this.addAuditInfo=row;
      this.addAuditForm={
         complainFee:row.salary==null?0:row.salary,
        correctErrorFee:'',
        objectionDate:'',
        complainDesc:'',
      }
    },
      uploadOverrun: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
     handleRemove: function(file, fileList) {
      console.log(file, fileList);
      this.addAuditImgList = fileList;
    },
     handleOnChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.addAuditImgList = fileList;
            console.log(this.addAuditImgList);
            //  let url=this.prewWorkerImg(res.data.data.id);
            //  this.skillImgList.push(res.data.data.fileUrl);
          }
        });
      }
    },
     confAddAudit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let auditImg = this.addAuditImgList.map(item => {
            return item.url;
          });
          let params = {
            serverNo:this.salaryInfo.worker.workerNo,
            type:this.addAuditInfo.salaryType,
            relationId:this.addAuditInfo.id,
            file: auditImg.join(","),
            complainFee: this.addAuditForm.complainFee,
            correctErrorFee: this.addAuditForm.correctErrorFee,
            objectionDate: this.addAuditForm.objectionDate,
            complainDesc: this.addAuditForm.complainDesc,
          };

          Service.$axiosAddNewComplain(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("提交成功");
              this.auditVisible = false;
              this.getSalaryInfo();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

 },
  showColumnDetail(row){
      this.columnDetailVisible=true;
      let salaryType=row.salaryType;
      let current=this.salaryTypeList.filter(item=>{return item.id==salaryType});
      let columnAttr=(current[0].columnAttr).split(',');
      let columnName=(current[0].columnName).split(',');
      let columnList=[];
      let len=columnAttr.length;
        for(let i=0;i<len;i++){
          let obj={
            key:columnAttr[i],
            value:columnName[i],
          };
          columnList.push(obj);
        }
     this.columnList=columnList;
     let columnData=[];
     let columnLine={};
      for(let i=0;i<len;i++){
          let itemObj={
            [columnAttr[i]]:row[columnAttr[i]],
          };
          Object.assign(columnLine,itemObj);
        }
        columnData.push(columnLine)
     this.columnData=columnData;
    },


  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.salary-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.worker-title{
  font-size:18px;
  font-weight: bold;
  margin-bottom:10px;
}
.info-item{
  margin-bottom: 6px;
  font-size: 14px;
}

</style>